import React, { useEffect, useState } from 'react';
import { ModuleView } from '@jadwalh/ui';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Select, Input } from '@jadwalh/ui';
import { Flex } from '@mantine/core';
import { useFormContext, Controller } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import instance from '../../../axios-instance';
import { WorkflowInfoWrapper } from './styles';
import MultiSelectDropdown from '../components/MultiSelectDropdownWithPortal';
import { useSelector } from 'react-redux';
import { getProfileData } from '../../../store/profile.slice';

function WorkflowInfo({ data, errors }: { data: any, errors: any }) {
  const { formatMessage } = useIntl();
  const { control, clearErrors, setValue } = useFormContext();
  const [selectedEvents, setSelectedEvents] = useState<string[]>([]);
  const profile = useSelector(getProfileData);
  const handleEventsChange = (selectedIds: string[]) => {
    setSelectedEvents(selectedIds);
    setValue('event_ids', selectedIds);
  };

  useEffect(() => {
    if (data?.events) {
      setSelectedEvents(
        data?.events?.map((event: any) => event.id?.toString())
      );
      setValue(
        'event_ids',
        data?.events?.map((event: any) => event.id?.toString())
      );
      setValue('name', data?.name);
    }
  }, [data]);

  const { data: events = [] } = useQuery({
    queryKey: ['events'],
    queryFn: () => instance.get(`/app/list/events?client_id=${profile.id}&status=1&scope=general&category=event`),
    select: (response: any) => response.data.data,
    refetchOnWindowFocus: false,
  });

  
  return (
    <WorkflowInfoWrapper>
      <ModuleView>
        <Flex direction="column" justify={'flex-start'} gap="16px">
          <h2 className="SemiBold">{formatMessage({ id: 'workflowInfo' })}</h2>
          <Input
            label={formatMessage({ id: 'workflowTitle' })}
            name="name"
            maxLength={55}
            registerOptions={{
              required: {
                value: true,
                message: formatMessage({
                  id: 'requiredField',
                }),
              },
            }}
          />
          <Flex direction="column" gap="4px">
            <p className="event-type-label">{formatMessage({ id: 'workflowEvents' })}</p>
            <MultiSelectDropdown
              items={
                events?.map((event: any) => ({
                  id: String(event.value),
                  name: String(event.label),
                })) || []
              }
              classes="events-container-select-wrapper"
              selectedItems={selectedEvents}
              onSelectionChange={handleEventsChange}
              placeholder={formatMessage({ id: 'chooseEvents' })}
              searchPlaceholder="البحث عن حدث"
              selectAllLabel="تحديد الكل"
              emptyLabel="لا توجد أحداث"
              position="below"
              usePortal={true}
              width={{ base: '100%', sm: '300px' }}
              btnClass={errors.event_ids ? 'hasError' : ''}
              clearError={clearErrors}
            />
            <Input
              name="event_ids"
              type="hidden"
              value={selectedEvents?.join(',') || ''}
              registerOptions={{
                required: {
                  value: true,
                  message: formatMessage({
                    id: 'requiredField',
                  }),
                },
              }}
            />
          </Flex>
        </Flex>
      </ModuleView>
    </WorkflowInfoWrapper>
  );
}

export default WorkflowInfo;
